import { AbsenceCategory, AbsenceCategorySchema } from "@myapp/contract";
import { ISelectOption } from "../../../shared/types/ISelectOption";

/**
 * Every category, in display order. Prefer this over `absenceCategoryOptions` outside of
 * `<Select>`: `ISelectOption.value` widens to `string | number | null`, so mapping the options
 * loses the `AbsenceCategory` type.
 */
export const ABSENCE_CATEGORIES = AbsenceCategorySchema.options;

export const CATEGORY_LABELS: Record<AbsenceCategory, string> = {
  SICK_LEAVE: "Krankheit",
  VACATION: "Urlaub",
  TRAINING: "Schulung",
  PERSONAL_LEAVE: "Privatzeit",
};

/**
 * Accepts null because ScheduleEntry.category is only populated for ABSENCE entries — a break
 * or an appointment block has none.
 */
export const getAbsenceCategoryLabel = (
  category: AbsenceCategory | null | undefined,
): string => (category ? CATEGORY_LABELS[category] : "Abwesenheit");

export const ABSENCE_CATEGORY_COLOR = "#BBA6D9";

export const absenceCategoryOptions: ISelectOption[] = ABSENCE_CATEGORIES.map(
  (category) => ({ value: category, label: CATEGORY_LABELS[category] }),
);
